<template>
  <div id="root" class="inquiry-root">
    <!-- navbar start -->
    <van-nav-bar class="first-bar" :title="title"
      :border="false" left-arrow fixed  @click-left="onClickLeft" />
    <!--navbar start -->
    <!-- {{ chatStep }} -->
    <!-- 聊天主体 start -->
    <div class="main" ref="main-box" >
      <div class="chat-box" v-for="(item,idx) in chatData" v-show="item.text" :key="item.text+idx">
        <div class="main-chat-item" v-if="item.flag == 'docker'">
          <img class="main-chat-item-left" src="@/icons/doc.png"></img>
          <!-- <div class="main-chat-item-left "></div> -->
          <div class="main-chat-item-right  ">
            <div class="right-name">医生小助</div>
            <div class="right-message">
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="main-chat-item chat-right" v-else>

          <div class="main-chat-item-right  ">
            <div class="message">{{ item.text }}</div>
          </div>
          <img class="main-chat-item-left" src="@/icons/nan.png" v-if="userinfo.sex =='1'"></img>
          <img class="main-chat-item-left" src="@/icons/nv.png" v-else></img>
        </div>
      </div>
    </div>
    <!-- 聊天主体 end -->

    <!-- 底部选择回答区域 开始 -->
    <div class="next-fixed-bottom" ref="next-fixed-bottom" v-if="!showLoading && chatStep < dockerData.length" >
      <div class="bottom-title">请回复 <span class="mul">{{ isRadio? "(单选)" :"(可多选)" }}</span></div>
      <div class="mul-box">
        <!-- 询问过敏 多选 开始 -->
        <template v-if="chatStep == 2">
           <div :class="[flagWu ? 'mul-box-item-active' : '', 'mul-box-item flex-4']" @click="selectClear('fou')">{{flagText[chatStep]}}</div>
           <div :class="[item.flag ? 'mul-box-item-active' : '', 'mul-box-item flex-4']" v-for="(item,index) in selectData" :key="item.name" @click="SelectItem(item,index)">{{ item.name? item.name:"" }}</div>
           <div class="mul-box-item mul-box-item-active flex-4" @click="goSelect">
            <span class="icon-plus">+</span>  
            添加
          </div>
        </template>
        <!-- 询问过敏 多选 结束 -->

        <!-- 询问肝肾功能 多选 开始-->
        <template v-else-if="chatStep == 3">
           <div :class="[flagWu ? 'mul-box-item-active' : '', 'mul-box-item']" @click="selectClear('fou')">{{flagText[chatStep]}}</div>
           <div :class="[item.flag ? 'mul-box-item-active' : '', 'mul-box-item']" v-for="item in selectData" :key="item.name" @click="SelectItem(item)">{{ item.name? item.name:"" }}</div>
        </template>
        <!-- 询问肝肾功能 多选 结束-->

        <!-- 询问是否处于妊娠期 单选 开始 -->
         <template v-else-if="chatStep == 4 && userinfo.sex !='1'">
           <div :class="[flagWu ? 'mul-box-item-active' : '', 'mul-box-item']" @click="selectClear('fou')">{{flagText[chatStep]}}</div>
           <div :class="[item.flag ? 'mul-box-item-active' : '', 'mul-box-item']" v-for="item in selectData" :key="item.name" @click="selectClear(item)">{{ item.name? item.name:"" }}</div>
        </template>
        <!-- 询问是否处于妊娠期 单选 结束 -->

        <!-- 询问是否预购 单选 开始 -->
         <template v-else-if="chatStep == 1">
           <div :class="[item.flag ? 'mul-box-item-active' : '', 'mul-box-item flex-2']" v-for="item in selectData" :key="item.name" @click="selectClear(item)">{{ item.name? item.name:"" }}</div>
        </template>
        <!-- 询问是否预购 单选 结束 -->

      </div>
      <div :class="[submitColor !=0 ? 'activesubmit' : '', 'bottom-submit']" @click="submitChat" v-if="!isRadio">发送</div>
    </div>
    <!-- 底部选择回答区域 结束 -->

    <!-- 医生正在回答中 开始 -->
    <div class="bottom-huifu" v-else>
      <div class="huifu-box">
        <img class="svg" src="@/icons/选中.png"></img>
        <div class="msg">医生正在回复，请耐心等待...</div>
      </div>
    </div>
    <!-- 医生正在回答中 结束 -->

    <!-- 当最后一个问题选择 否的时候 需要弹框 start-->
    <van-dialog v-model:show="show" title="平台监管提示" confirm-button-text="我知道了" confirm-button-color="#00b955" >
        <div class="neirong">根据国家互联网医院管理办法，平台仅为复诊患者提供服务，如您不是复诊患者则无法开具处方。</div>
    </van-dialog>
    <!-- 当最后一个问题选择 否的时候 需要弹框 end-->

    <!-- 当点击返回的时候 需要弹框 start-->
    <van-dialog v-model:show="exitShow" @cancel="exitCancel" title="退出问诊提示" show-cancel-button cancel-button-text="退出问诊" 
    confirm-button-text="继续问诊" confirmButtonColor="#00B955" confirm-button-color="black" >
        <div class="neirong">
          确定要退出问诊吗？退出后会结束本次问诊，且不会开具处方，如需开具处方可重新发起问诊。
        </div>
    </van-dialog>
    <!-- 当点击返回的时候的时候 需要弹框 end-->

       <!--  //拦截卡片 -->
  <van-popup v-model="allergyFlagShow" position="bottom" :style="{ height: '80%' }" :close-on-click-overlay="false">
    <intercept :cardLit="cardLit" @goBack="exitCancel" @next="next" />
  </van-popup>
  <LoadingComponent :is-show="isShowLoading" />

    <van-dialog
      use-slot
      title="未匹配到医生"
      v-model="dialogShow"
      confirm-button-text="我知道了" confirm-button-color="black"
      @confirm="drugLimitDockeConfirm"
    >
      <div class="box" style="padding: 15px;">
        <div class="box_text" style="text-indent: 2em;">您好，根据平台监管要求，本次问诊涉及了限制类抗菌药物，对开方医生职称有要求，</div>
        <div class="box_text" style="text-indent: 2em;">当前暂无可开方医生，您可以稍后重新发起，或去除限制类药物重新问诊。涉及的限制类的物:</div>
      </div>
      <div style="padding: 15px; overflow-y: scroll; max-height: 100px; padding-top: 0px;">
        <div v-for="(item,index) in drugLimitDockerList" class="line" :key="item.commonName+item.limitTypeName+index" style="color:#07A9F0;">{{index+1}}、{{item.commonName}}（{{item.limitTypeName}}）</div>
      </div>
    </van-dialog>

  </div>
</template>
<script>
import { getInquiryInteractiveMessage, getInquiryAreaRuleByOrganSign,patientInfoAndGotoInquir } from "../../api/index"
import { getSign,limitDrugAudit } from '../../api/video'
import intercept from "../interrogationInfo/intercept.vue"
import LoadingComponent from '@/components/Loading'
import { getCookie } from '@/utils/auth'
import { initLog } from '@/utils/index'
import { Dialog } from "vant";
const allergyList = [{flag: false, value: '青霉素', name:'青霉素'}, {flag: false,value: '头孢', name:'头孢'}];  // 过敏史
export default {
  components: {
    LoadingComponent,
    intercept
  },
  data() {
    return {
      drugLimitDockerList:[],// 未匹配医生
      dialogShow:false,// 抗菌类药品提示框
      isShowLoading: false,
      ansList:[],
      ansListV:[],
      time:{},
      userinfo:{},
      cardLit:[],
      inquiryAreaRule: {},
      allergyFlagShow: false,
      title: '问诊中',
      show: false,
      exitShow: false,
      submitColor:false,
      chatData: [], 
      radioIdx: [1, 4],
      flagText:['','','无','无异常','否'],
      dockerData: [], // 用来存放医生的所有句子
      // 存放底部所有症状
      optionLimit: 5, // 最大限制选择5条
      optionData: [
        [],
        [{value: 0, name: '否',flag: false }, {value: 1, name: '是',flag: false}],  // 是否复诊
        [{flag: false, value: '青霉素', name:'青霉素'}, {flag: false,value: '头孢', name:'头孢'}],  // 过敏史
        [{flag: false, value: 1, name:'肝功能异常'}, {flag: false,value: 2, name:'肾功能异常'}], 
        [{flag: false, value: 1, name:'妊娠期'}, {flag: false,value: 2, name:'哺乳期'}], 
      ],
      flagWu: false,  // 判断症状选的是否是 否 或者 无
      ansText: "", // 用户发送的消息
      showLoading: false ,  // 是否展示   医生正在回复中...
      chatStep: 0 // 0 表示用户 在选择 头孢 过敏啥的     1 表示 用户在选择肝肾功能 是否正常   2 表示用户在选择妊娠期   3 表示用户在选择预购的药品
    }
  },
  computed:{
    isRadio(){ return this.radioIdx.includes(this.chatStep)},
    selectData(){ return this.optionData[this.chatStep] }
  },
  beforeRouteEnter(to, from, next){
    if(from.path=="/allergySelect"){
      next(vm => {
        const {value} = vm.$route.query
        if(!value || !value.value || !value.name)return;
        
        const isExist = vm.optionData[vm.chatStep].find((item)=>{
          return value.name == item.name
        })
        if(!isExist){
          vm.optionData[vm.chatStep].push({flag: true, value: value.value, name: value.name})
        }else{
          isExist.flag = true
        }
        vm.flagWu = false; 
        vm.submitColor++;
        vm.autoSetHight('auto');
      })
    }else{
      next(vm=>{ 
        Object.assign(vm.$data, vm.$options.data())
        vm.init()
      })
    }
  },

  mounted(){
    //   this.optionData = allergyList;
  },
  methods: {
    drugLimitDockeConfirm(){
      this.dialogShow = false ;
      this.drugLimitDockerList = [];
      this.$router.push("/interrogationInfoText")
    },
    exitCancel() {
      this.allergyFlagShow = false
      if (this.$route.query.thirdPartyPrePrescriptionId != null && this.$route.query.thirdPartyPrePrescriptionId != undefined) {
        this.$router.push({
          path: 'interrogationInfoText',
          query: { thirdPartyPrePrescriptionId:  this.$route.query.thirdPartyPrePrescriptionId}
        })
      }else {
        this.$router.push("/interrogationInfoText")
      }
      
    },
    SelectItem(item,index) {
      // 移除过敏原的选项
      if(this.chatStep === 2 && item.flag && index > 1){
        const list = this.optionData[this.chatStep].filter(it => it.value !== item.value);
        this.$set(this.optionData, this.chatStep, list)
      }
      item.flag = !item.flag
      this.flagWu = false; 
      this.submitColor = this.selectData.filter(it=>it.flag).length;
    },
    goSelect() {
      if(this.chatStep == 2 && this.optionData[2].length >= this.optionLimit + 2){
        return this.$toast({ message: `过敏史至多添加${this.optionLimit}项`, duration: 1500 })
      }
      //  选择 过敏 症状
     this.$router.push({ path: '/allergySelect', query: { type: "allergySelect" } })
    },
    selectClear(item) {
      // 如果是多选   则将所有选择 取消掉
      if(item == 'fou' || this.chatStep == 2){//过敏史选择否
            this.$set(this.optionData,2,[])
            this.optionData[2] = [...allergyList]
      }
      this.selectData.forEach((item) => item.flag = false)

      // 点击 无 和其他状态互斥
      this.flagWu = true; 
      this.submitColor++; 
      // 以下针对 第3、4种情况
      if (item && item != 'fou') {
          this.flagWu = false; 
          this.submitColor--; 
          item.flag = true; 
      }
      this.isRadio && this.submitChat(); 
    },
    autoSetHight(behavior){
      this.$nextTick(()=>{
        const mainBox = this.$refs['main-box'];
        const fixedBox = this.$refs['next-fixed-bottom'];
        if(mainBox){
          mainBox.style.height = `calc(100vh - ${fixedBox?fixedBox.scrollHeight+60:203}px)`
          mainBox.scrollTo({top: mainBox.scrollHeight+150, behavior: behavior || 'smooth'});
        }
      })
    },
    submitChat() {
      let selectCnt = 0; 
      let selectone = null; 
      let ansValue = null;
      this.selectData.forEach((item) => {
        if (item.flag) {
          if (selectone == null) selectone = item; 
          selectCnt++; 
          item.name = item.name || ''
          item.value = item.value || ''
          if (selectCnt == 1){
            this.ansText += item.name;
            ansValue = item.value
          } else{
            this.ansText += " " + item.name;
            if(isNaN(item.value)){
              ansValue += " " + item.value
            } else{
              ansValue +=  item.value
            }
          }
        }
      })

      // 监管弹框
      if (this.chatStep == 1 && selectone.name == "否") {
        this.show = true; 
        this.ansText = ""
        return; 
      }

      //  无和否 的处理
      if (this.flagWu) {
        selectCnt++; 
        this.ansText = this.flagText[this.chatStep]
        ansValue = 0;
      }

      //  当点击 发送按钮的时候 需要判断
      if (selectCnt == 0) return this.$toast({ message: "至少选择一项", duration: 1500 })

      // 过敏史 回复 时间戳
      let key = '', qusKey = '';
      const ansTime = Date.now();
      switch (this.chatStep) {
        case 1:
          qusKey = 'allergySymptomQuestionTime';
          key = 'subsequentVisitAnswerTime';
          break;
        case 2:
          qusKey = 'liverAndKidneyAbnormalQuestionTime';
          key = 'allergySymptomAnswerTime';
          break;
        case 3:
          if(this.userinfo.sex == 2){
            qusKey = 'gestationAndLactationQuestionTime';
          }
          key = 'liverAndKidneyAbnormalAnswerTime';
          break;
        case 4:
          key = 'gestationAndLactationAnswerTime';
          break;
      }
      if(key) this.$set(this.time, key, ansTime);

      // 用户选的症状 都会变成一条 消息
      this.chatData.push({ flag: "patient", text: this.ansText })
      this.ansList.push(this.ansText)
      this.ansListV.push(ansValue)

      this.autoSetHight();
      // 显示 医生 正在回复种
      this.showLoading = true; 
      const isNext = this.dockerData[this.chatStep + 1]
      if(qusKey)this.$set(this.time, qusKey, Date.now() + 1500);

      setTimeout(() => {
        if(isNext){
          if (this.dockerData[this.chatStep] == undefined) return; 

          const dt = this.dockerData[++this.chatStep]
          dt && this.chatData.push(dt)

          this.showLoading = false; 
          this.ansText = ""
          this.submitColor = 0 ; 
          this.flagWu = false; 

          this.autoSetHight();
        }else{
          this.getLimitDrugAudit()
        }
      }, Math.floor(Math.random() * (1000 + 1)) + 1000);

    },
    onClickLeft() {
      this.exitShow = true; 
    },
    async init() {

      const {params={}} = JSON.parse(localStorage.getItem('newimParams') || '{}')
      this.userinfo = params;
      const {data={}} = await getInquiryInteractiveMessage().catch(e=>console.log)
      const {
        beginQuestionMsg, // 已收到消息提示
        subsequentVisitQuestionMsg, // 是否在线下就诊过
        allergySymptomQuestionMsg, allergySymptomAnswerMsg,  // 过敏史
        liverAndKidneyAbnormalQuestionMsg, liverAndKidneyAbnormalAnswerMsg, // 肝肾
        gestationAndLactationQuestionMsg, gestationAndLactationAnswerMsg, // 妊娠期
      } = data.data

      // 初始化 所有医生的消息
      let s1 = beginQuestionMsg || "您好，已收到您的问诊申请，为保障问诊内容的准确分析，请如实回答以下提问！"; 
      let s2 = subsequentVisitQuestionMsg || "请问您是否在线下医疗机构就诊过，并使用过此次预购的药品?"; // 0 
      let s3 = allergySymptomQuestionMsg || "请问，您是否有过敏史?" // 1
      let s4 = liverAndKidneyAbnormalQuestionMsg || "请问，您的肝、肾功能有无异常?" // 2 
      let s5 = gestationAndLactationQuestionMsg || "请问，您当前是否处于妊娠期或哺乳期?" // 3 
      let list = [s1, s2, s3, s4]

      // 选项
      
      // 判断当前用户是否为女性
      if(this.userinfo.sex == 2) list.push(s5)

      // 将医生的第一第二条消息 先放入页面中
      this.dockerData = list.map((item, index) => {
        const o = { text: item, flag:"docker" }
        if (index < 2) { this.chatData.push(o) }
        return  o
      })
      // this.time["allergySymptomQuestionTime"] = Date.now(); // 过敏史
      // 复诊问答时间
      this.$set(this.time, 'subsequentVisitQuestionTime', Date.now());
      // this.$set(this.time, 'subsequentVisitAnswerTime', Date.now() + Math.floor(Math.random() * (3000 - 1000 + 1)) + 1000);
      this.chatStep++;  // 用来标记 医生的第几句话
    },

    // 查询拦截数据
    async getLimitDrugAudit(){
      const limitData = JSON.parse(localStorage.getItem('limitDrugAudit') || "{}")
      const dt = this.ansListV
      // 过敏
      if(dt && dt[1]){ limitData.integerList = dt[1].split(" ") }
      // 肝、肾功能异常
      if(dt && dt[2]){ limitData.healthSituation = dt[2]   }
      // 孕妇妊辰期、哺乳期
      if(dt && dt[3]){ limitData.womenSituation = dt[3] }

      this.isShowLoading = true
      const ret = await limitDrugAudit(limitData)
      this.isShowLoading = false
      if(ret.result == null || ret.result.length==0){
         this.getInquiryAreaRuleBefore()
      }else{
        this.cardLit = ret.result
        this.allergyFlagShow = true
      }
    },
    // 根据门店organSign获取问诊规则
    async getInquiryAreaRuleBefore(){
      try {
        this.isShowLoading = true
        const res = await getInquiryAreaRuleByOrganSign({ param: getCookie('native_organSign') })
        if (res.data.code == 0) {
          this.inquiryAreaRule = res.data.result
          this.toPrescription();
        }
      } catch (err) {
        console.log(err & err.msg)
        this.isShowLoading = false;
      }
    },
    setLog(msg) {
      $hyjkLoggerSdk.info(initLog(msg), "PATIENTH5");
    },
    toPrescription(e) {
      this.isShowLoading = true
      // 检查表单是否可提交，true-可提交,false-不可提交
      this.setLog({ message: '点击去开方', type: '/interrogationInfoText' })
      if (this.getInquiryAreaRuleByOrganSign(this.inquiryAreaRule)) {
        this.isShowLoading = false
        return
      }
      let {params = {}, medicines = []} = JSON.parse(localStorage.getItem('newimParams'));
      //处理含麻字段
      //************************
      let containEphedrine = false
      if (params.lastDiagnosis) {
        let medicineDetailArr = params.lastDiagnosis.prescriptionDetail
        if (medicineDetailArr) {
          if (medicineDetailArr.length) {
            medicineDetailArr.forEach((item) => {
              if (item.containEphedrine) {
                containEphedrine = true
              }
            })
          }
        }
      }
      if(containEphedrine && !params.idCard) {
        Dialog.confirm({
          title: '提示',
          message: '预购药品中，存在含麻黄碱类复方制剂，请填写身份证信息',
          confirmButtonText: "我知道了",
          confirmButtonColor: "#01b956",
          showCancelButton: false,
          width: "300px"
        })
        this.isShowLoading = false
      } else {
        // 图文问诊
        this.goInquiry()
      }
    },

    getInquiryAreaRuleByOrganSign(data){
      let gtAge = data.gtAge
      let ltAge = data.ltAge
      let toInquiry = data.toInquiry
      let message
      let age = this.userinfo.customAge
      let flagStatus = false
      if (toInquiry == 2 && this.ansListV[3] && this.userinfo.sex == '2') {
        if (age < ltAge && ltAge) {
          message = `根据合规要求，${ltAge}岁以下患者以及孕妇禁止发起问诊，需前往线下医疗机构就诊`
          flagStatus = true
        } else if (age >= gtAge && gtAge) {
          message = `根据合规要求，${gtAge}岁以上患者以及孕妇禁止发起问诊，需前往线下医疗机构就诊`
          flagStatus = true
        } else {
          message = '根据合规要求，孕产妇患者禁止线上问诊，需前往线下医疗机构就诊'
          flagStatus = true
        }
      } else {
        if (age < ltAge && ltAge) {
          message = `根据合规要求，${ltAge}岁以下患者禁止发起问诊，需前往线下医疗机构就诊`
          flagStatus = true
        } else if (age >= gtAge && gtAge) {
          message = `根据合规要求，${gtAge}岁以上患者禁止发起问诊，需前往线下医疗机构就诊`
          flagStatus = true
        }
      }
      flagStatus && Dialog.confirm({
        title: '提示',
        message: message,
        confirmButtonText: "我知道了",
        confirmButtonColor: "#01b956",
        showCancelButton: false,
        width: "300px"
      })
      return flagStatus
    },
    next(){
      this.allergyFlagShow = false
      this.goInquiry()
    },
    handlerParams(params) {
      const result = {}
      for (var key in params) {
        result[key] = params[key]
      }
      const limitData = JSON.parse(localStorage.getItem('limitDrugAudit') || "{}")
      result.lastDiagnosis.birthday = limitData.birthday || ''
      result.lastDiagnosis = JSON.stringify(result.lastDiagnosis)
      if (this.$route.query.thirdPartyPrePrescriptionId != null && this.$route.query.thirdPartyPrePrescriptionId != undefined) {
        result.thirdPartyPrePrescriptionId = this.$route.query.thirdPartyPrePrescriptionId
      }
      return result
    },
    // 提交
    async goInquiry(){
      let {params = {}, medicines = []} = JSON.parse(localStorage.getItem('newimParams'));
      const data = await getSign({});
      const { employeeId, roomNumber, userSign } = data.result
      const ids = {
        roomNumber,
        employeeId,
        userSign,
        imPlatform: getCookie('native_support_tim') || '0'
      }
      Object.assign(params, ids)
      const uploadParams = Object.assign({}, params, { lastDiagnosis: '' })
      this.setLog({
        message: `获取房间号成功,roomNumber: ${JSON.stringify(  uploadParams  )}`,
        type: '/interrogationInfoText'
      })
      this.setLog({
        message: `发起问诊预购药品medicineArr: ${JSON.stringify(medicines)}，房间号：${roomNumber}`,
        type: '/interrogationInfoText'
      })

      // 拼接用户回复的参数
      params.allergySymptom = this.ansListV[1] ? '2' : '1'; // 过敏数据
      params.allergySymptomExplain = this.ansListV[1] || ''; // 过敏数据
      params.liverAndRenalFunction = this.ansListV[2] ? 1 : 0; // 肝肾功能异常  0:'否', 1'肝功能异常',2:'肾功能异常'，3：肝肾都异常
      params.pregnancyAndLactation = this.ansListV[3] ? 1 : 0; // 女性是否妊娠期、哺乳期 0:'否', 1'妊娠期',2:'哺乳期'

      params.lastDiagnosis.pregnancyAndLactationValue = this.ansListV[3] || 0;
      params.lastDiagnosis.liverAndRenalFunctionValue = this.ansListV[2] || 0;

      params.lastDiagnosis.teletextInquiryInteractionOptimizeSwitch = 1

      // 设置问答时间戳
      Object.assign(params.lastDiagnosis, this.time);
      params.lastDiagnosis.prescriptionDetail.forEach((item)=>{
              item.singleDoseValue = item.singleDose
      })           //todo4003
      const res = await patientInfoAndGotoInquir(this.handlerParams(params)).catch((err) => {
        if(err.code == 4003) {
          this.setLog({ message: '提交表单并问诊失败', type: '/askDockerChat'})
          this.dialogShow = true ;
          this.drugLimitDockerList = err.result.inquiryAntibacterialDrugDetailDtoList ;
        }else {
          this.$toast({ message: err.msg || err})
          this.setLog({ message: '提交表单并问诊失败', type: '/askDockerChat'})
        }
      });
      this.isShowLoading = false
      if(res) {
        const selectedList = JSON.parse(localStorage.getItem("selectedList")||"[]");
        const diagnoseList = selectedList.map((item, index) => ({
          diagnosis_name: item.diagnosisName,
          diagnosis_code: item.diagnosisCode,
          diagnosis_type: item.diagnosisType == 1 ? 0 : item.diagnosisType == 2? 1 : 2,
          diagnosis_seq: index,
          check: item.active
        }))
        diagnoseList.forEach(item =>  window.webSdk.track('ds_page_diagnosis', item))
        this.setLog({ message: `提交表单并问诊成功,roomNumber: ${JSON.stringify(uploadParams )}`})
        params.patientGuid = res.patientGuid
        this.$store.commit('setInquiryRecordGuid', res.inquiryReportGuid) // 问诊GUID
        this.$store.commit('setRoomNumber', uploadParams.roomNumber)
        this.$store.commit('setPatientGuid', res.patientGuid)
        localStorage.setItem('params', JSON.stringify(params))
        localStorage.setItem('organSign', getCookie('native_organSign'))
        const appUrl = `protocol://action/go_im_reception?inquiryId=${ res.inquiryReportGuid }&roomNumber=${ uploadParams.roomNumber }&patientGuid=${ res.patientGuid }`
        // const WVJBIframe_1 = document.createElement('iframe')
        // WVJBIframe_1.style.display = 'none'
        // WVJBIframe_1.src = appUrl
        // document.documentElement.appendChild(WVJBIframe_1)
        // setTimeout(()=>{document.documentElement.removeChild(WVJBIframe_1)}, 0)
        window.location.href = appUrl
      }
     
    }

  },
  mounted(){
    // 复诊问答时间
    this.$set(this.time, 'subsequentVisitQuestionTime', Date.now());
   
    const name = this.$route.name
    const next = window.clickNativeBack || null;
    // 主动出发安卓返回按钮  //点击安卓底部返回时
    window.clickNativeBack = () => {
      if (name === 'askDockerChat') {
          this.exitShow = !this.exitShow;
          return false;
      }
      next && next();
    }
  }
}
</script>

<style scoped lang="scss">
.loading-box{
  background-color: #434343;
  color:#fff;
  padding: 30px 0;
}
.van-dialog__header {
  font-weight: 500!important;
  color: #111334;
}
.van-dialog__content {
  .neirong {
    padding: 15px 30px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #41435D;
    text-align: justify;
    p {
      text-indent:2em;
    }
  }
}
.main {
  padding: 0 15px 20px;
  height: calc(100vh - 203px);
  overflow-y: auto;

  .main-chat-item {
    &:first-child {
      margin-top: 6px;
    }
    margin-bottom: 16px;
    display: flex;
    .main-chat-item-left {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      margin-right: 6px;
    }
    .main-chat-item-right {
      .right-name {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 11px;
        color: #999999;
        letter-spacing: 0;
        line-height: 11px;
        margin-bottom: 6px;
      }
      .right-message {
        max-width: 223px;
        background-color: white;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 15px;
        color: #111734;
        border-radius: 0 10px 10px 10px;
        padding: 10px;
        margin-right: 6px;
      }
      .message {
        max-width: 223px;
        background-color: white;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 15px;
        background-color: #00b955;
        padding: 10px;
        margin-right: 6px;
        border-radius: 10px 0 10px 10px;
        color: white;
      }
    }
  }
  .chat-right {
    display: flex;
    justify-content: flex-end;
  }
}
.bottom-huifu {
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 9px 15px;
  .huifu-box {
    display: flex;
    font-size: 15px;
    color: #111734;
    background-color: white;
    border-radius: 30px;
    padding: 6px 6px;
    box-shadow: 0 5px 20px 0 #30303c14;
    width: 60%;
  }
  .svg {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
}
.next-fixed-bottom {
  width: 100%;
  padding: 12px 15px;
  background: #fff;
  border-top: 1px solid #ededed;
  border-radius: 15px 15px 0 0;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  .bottom-title {
    margin-bottom: 10px;
    color: #111734;
    font-size: 16px;
    font-weight: 500;
    font-weight: 500;
    .mul {
      color: #999999;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .mul-box {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    margin-top: 14px;
    margin-bottom: 14px;
    width: 100%;
    max-height: 130px;
    overflow-y: auto;
    .mul-box-item {
      font-size: 14px;
      width: 26%;
      padding: 4px 10px;
      background-color: #f2f3f7;
      border-radius: 16px;
      text-align: center;
      border: 1px solid transparent;
      margin-bottom: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .mul-box-item-active {
      border: 1px solid #00B955;
      color: #00B955;
      background-color: white;
    }
    .flex-4 {
      width: 18%; 
      padding: 4px 6px;
    }
    .flex-2 {
      width: 42%;
      padding: 8px 10px;
    }
  }
  .bottom-submit {
    width: 100%;
    background-color: #c6cad4;
    text-align: center;
    border-radius: 50px;
    color: white;
    font-size: 18px;
    padding: 8px 0;
  }
  .activesubmit {
    background-color: #00b955;
  }
}
#root {
  /deep/ {
    .van-radio__icon--checked .van-icon,
    .van-checkbox__icon--checked .van-icon {
      background-color: #01b956 !important;
      border-color: #01b956 !important;
    }
    .van-radio-group {
      .van-radio {
        margin: 0;
        &:last-child {
          margin-left: 40px;
        }
      }
    }
    .van-radio__icon,
    .van-checkbox__icon {
      font-size: 20px;
    }
    .van-cell {
      padding-right: 15px;
    }
    .van-nav-bar__title {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
    .van-nav-bar__text {
      font-size: 15px;
      color: #333;
      font-weight: 400;
    }
    .van-field--disabled .van-field__label {
      color: #323233;
    }
    .inputMedicine {
      &.van-field--disabled {
        &:after {
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 0;
          bottom: 0;
          left: 0.42667rem;
          border-bottom: 1px solid #f7f7f7;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
      }
    }
    input,
    textarea {
      &::placeholder {
        color: #999;
      }
    }
    .interrogationInfo-group {
      &[class*='van-hairline']::after {
        border-top: none;
        border-color: #f7f7f7;
      }
      [class*='van-hairline']::after {
        border: none;
        border-color: #f7f7f7;
      }
    }
    .van-cell::after {
      border-bottom: 1px solid #f7f7f7;
    }
  }
}
#root {
  padding: 55px 0 0;
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
  &.setHeight {
    padding-top: 0;
  }
}

.inquirytype {
  display: flex;
  align-items: center;
  .inquirytype-item {
    display: flex;
    align-items: center;
    margin-left: 15px;
    width: 165px;
    height: 57px;
    border-radius: 8px;
    box-shadow: 0px 0px 15px 0px rgba(48, 48, 60, 0.05);
    font-size: 16px;
    font-weight: 400;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    .inquirytype-item_photo {
      margin: 0 10px 0 25px;
    }
    &.active {
      background: rgba(1, 185, 86, 0.05) !important;
      border: 1px solid #01b956;
    }
    &:first-child {
      margin-left: 0;
    }
  }
  .inquiryText {
    position: relative;
    .inquiryHot {
      position: absolute;
      bottom: 45px;
      left: 124px;
      width: 50px;
      height: 21px;
    }
  }
}
.content {
  position: relative;
  height: 100%;
  overflow-y: auto;
}
.setHeight {
  height: calc(100vh - 50px) !important;
}

.bottom-bar {
  background: white;
  z-index: 99;
  position: fixed;
  bottom: 0px;
  left: 0;
  display: flex;
  padding: 12px 15px 12px 24px;
  width: calc(100% - 39px);
  justify-content: space-between;
  align-items: center;
}

.disabled {
  background: rgba(200, 200, 200, 1);
  color: rgba(255, 255, 255, 1);
  border: 1px solid #c8c8c8;
}
p {
  margin: 0;
}

#root {
  height: 100vh;
  background-color: #f7f7f7;
  box-sizing: border-box;
  .first-bar {
    z-index: 1000;
  }
}

.icon-plus{
  font-size: 16px;
}
</style>
